module.exports = __webpack_public_path__ + "static/media/woo13.19c9f135.png";